/**
 * O menu da conta, no canto do topo — spec 0087.
 *
 * Era um `div` que abria no clique e fechava no clique fora: sem Esc, sem
 * setas, e o leitor de tela não sabia que havia um menu. Agora é o menu do
 * Radix (`ui/dropdown-menu`), que traz as três coisas.
 */
import type { Ref } from 'react';
import { ChevronDown, LogOut, User } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from '../ui/dropdown-menu';

interface Props {
  nome: string;
  onMeusDados: () => void;
  onSair: () => void;
  /** O botão da conta, para quem abre uma janela pelo menu devolver o foco a ele. */
  gatilho?: Ref<HTMLButtonElement>;
}

/** As iniciais do nome, para o círculo: "Ana Ferreira" vira "AF". */
const iniciais = (nome: string): string => {
  const partes = nome.trim().split(/\s+/).filter((p) => /\p{L}/u.test(p[0] ?? ''));
  if (partes.length === 0) return '?';
  const primeira = partes[0][0] ?? '';
  const ultima = partes.length > 1 ? partes[partes.length - 1][0] ?? '' : '';
  return (primeira + ultima).toUpperCase();
};

export function MenuDaConta({ nome, onMeusDados, onSair, gatilho }: Props) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger ref={gatilho} className="casca-conta" aria-label={`Conta de ${nome}`}>
        <i className="casca-conta-iniciais" aria-hidden="true">{iniciais(nome)}</i>
        <span className="casca-conta-nome">{nome}</span>
        <ChevronDown size={14} aria-hidden="true" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="casca-conta-menu">
        <DropdownMenuLabel className="casca-conta-rotulo">{nome}</DropdownMenuLabel>
        <DropdownMenuSeparator className="casca-conta-divisoria" />
        <DropdownMenuItem className="casca-conta-item" onSelect={onMeusDados}>
          <User size={16} aria-hidden="true" /> Meus dados
        </DropdownMenuItem>
        <DropdownMenuItem className="casca-conta-item casca-conta-sair" onSelect={onSair}>
          <LogOut size={16} aria-hidden="true" /> Sair
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
